export const PromoPath = '/promo';

export const getPromoTitle = (): string => 'Promo';
